import { F as o } from "../../../vendor-EQDp64ng.js";
const e = "global", t = o();
export {
  e as GLOBAL_SCOPE,
  t as IS_MAC
};
